export default __webpack_public_path__ + "static/media/antenna.13ca0ee4.svg";